export const TICKET_TYPES_LOAD = 'TICKET_TYPES_LOAD';
export const TICKET_TYPES_LOAD_SUCCESS = 'TICKET_TYPES_LOAD_SUCCESS';
export const TICKET_TYPES_LOAD_ERROR = 'TICKET_TYPES_LOAD_ERROR';
/*
export const TICKET_TYPES_UPDATE = 'TICKET_TYPES_UPDATE';
export const TICKET_TYPES_UPDATE_SUCCESS = 'TICKET_TYPES_UPDATE_SUCCESS';
export const TICKET_TYPES_UPDATE_ERROR = 'TICKET_TYPES_UPDATE_ERROR';
*/